import { type } from 'ot-text';
import * as share from 'sharedb/lib/client/index.js';
share.types.register(type);

export { share };
